import { makeStyles } from '@material-ui/core/styles';
import typography from '@/theme/typography';

const useStyles = makeStyles(
  (muiTheme) => ({
    taxonomyColumns: {
      paddingTop: '24px',
      width: '100%',

      '& ul': {
        margin: 0,
        paddingInlineStart: '1rem',
      },

      [muiTheme.breakpoints.down('sm')]: {
        '& .column': {
          paddingBottom: 0,
          paddingTop: 0,
        },
      },
    },
    taxonomyColumnHeading: {
      ...typography.subtitle2,
    },
  }),
  { name: 'GenTPDTaxonomySummaryBlock' },
);

export default useStyles;
